import React from 'react';

// constants
import {
  ADD_EMPLOYEE_SESSION,
  BACK,
  EDIT_EMPLOYEE_SESSION,
  STATE_OPTIONS,
} from './constants';

import TopToolbar from '../global/subcomponents/topToolbar/TopToolbar';

import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SaveIcon from '@material-ui/icons/Save';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { parse } from 'date-fns';
import './EmployeeSession.css';

class EmployeeSessionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.getValue('name'),
      clockIn: this.getValue('clockIn'),
      clockOut: this.getValue('clockOut'),
      totalHours: this.getValue('totalHours'),
      totalPay: this.getValue('totalPay'),
      state: this.getValue('state'),
      hourlyRate: 0,
      requiredList: ['name', 'clockIn'],
      editEmployeeSession: this.props.editEmployeeSession,
      selectedClockInDate: null,
      selectedClockInTime: null,
      selectedClockOutDate: null,
      selectedClockOutTime: null,
    };
  }

  componentDidMount() {
    if (this.props.editEmployeeSession) {
      console.log(this.props.editEmployeeSession);

      const selectedEmployee = this.props.employees.find(
        (user) => user.userId === this.props.editEmployeeSession.userId
      );

      const hourlyRate = parseInt(selectedEmployee?.employeePerHour ?? 0);
      this.setState({
        name: selectedEmployee,
        hourlyRate,
        // hourlyRate: parseInt(selectedEmployee.employeePerHour)
      });

      const { clockIn, clockOut } = this.state;
      if (clockIn) {
        try {
          const parsedDate = parse(clockIn, 'MM/dd/yyyy h:mm a', new Date());
          this.setState({
            clockIn: parsedDate,
            selectedClockInDate: parsedDate, // Set date for date picker
            selectedClockInTime: parsedDate, // Set time for time picker
          });
        } catch (error) {
          console.error('Error parsing clockIn:', error);
        }
      }

      if (clockOut) {
        try {
          const parsedDate = parse(clockOut, 'MM/dd/yyyy h:mm a', new Date());
          this.setState({
            clockOut: parsedDate,
            selectedClockOutDate: parsedDate, // Set date for date picker
            selectedClockOutTime: parsedDate, // Set time for time picker
          });
        } catch (error) {
          console.error('Error parsing clockIn:', error);
        }
      }
    }
  }

  calculateTotalHours = () => {
    const { clockIn, clockOut } = this.state;
    if (clockIn && clockOut) {
      const clockInDate = new Date(clockIn);
      const clockOutDate = new Date(clockOut);
      const diffInMilliseconds = clockOutDate - clockInDate; // Difference in milliseconds
      const diffInHours = diffInMilliseconds / (1000 * 60 * 60); // Convert milliseconds to hours
      return diffInHours.toFixed(2); // Limit to 2 decimal places
    }
    return 0;
  };

  // This function calculates total pay based on total hours and hourly rate
  calculateTotalPay = () => {
    const totalHours = parseFloat(this.state.totalHours) || 0;
    const totalPay = totalHours * this.state.hourlyRate;
    return totalPay.toFixed(2); // Limit to 2 decimal places
  };

  handleClockInDateChange = (dateInput) => {
    let date = new Date(dateInput?.toString());
    if (date.toString() === 'Invalid Date') {
      return;
    }
    this.setState({ selectedClockInDate: date }, this.updateClockIn);
  };

  handleClockOutDateChange = (dateInput) => {
    let date = new Date(dateInput?.toString());
    if (date.toString() === 'Invalid Date') {
      return;
    }
    this.setState({ selectedClockOutDate: date }, this.updateClockOut);
  };

  handleClockInTimeChange = (timeInput) => {
    let time = new Date(timeInput?.toString());
    if (time.toString() === 'Invalid Date') {
      return;
    }
    this.setState({ selectedClockInTime: time }, this.updateClockIn);
  };

  handleClockOutTimeChange = (timeInput) => {
    let time = new Date(timeInput?.toString());
    if (time.toString() === 'Invalid Date') {
      return;
    }
    this.setState({ selectedClockOutTime: time }, this.updateClockOut);
  };

  updateClockIn = () => {
    const { selectedClockInDate, selectedClockInTime } = this.state;
    if (selectedClockInDate && selectedClockInTime) {
      const combinedDate = new Date(selectedClockInDate);
      combinedDate.setHours(selectedClockInTime.getHours());
      combinedDate.setMinutes(selectedClockInTime.getMinutes());
      combinedDate.setSeconds(selectedClockInTime.getSeconds());
      combinedDate.setMilliseconds(selectedClockInTime.getMilliseconds());
      const isoString = combinedDate.toISOString();
      this.setState({ clockIn: isoString }, this.updateHoursAndPay);
    }
  };

  updateClockOut = () => {
    const { selectedClockOutDate, selectedClockOutTime } = this.state;
    if (selectedClockOutDate && selectedClockOutTime) {
      const combinedDate = new Date(selectedClockOutDate);
      combinedDate.setHours(selectedClockOutTime.getHours());
      combinedDate.setMinutes(selectedClockOutTime.getMinutes());
      combinedDate.setSeconds(selectedClockOutTime.getSeconds());
      combinedDate.setMilliseconds(selectedClockOutTime.getMilliseconds());
      const isoString = combinedDate.toISOString();
      this.setState({ clockOut: isoString }, this.updateHoursAndPay);
    }
  };

  updateHoursAndPay = () => {
    const totalHours = this.calculateTotalHours();
    const totalPay = this.calculateTotalPay();
    this.setState({
      totalHours,
      totalPay,
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  handleStateChange = (name, value) => {
    this.setState({
      [name]: value ? value : null, // Store the name of the selected option
    });
  };

  isHandleSave = () => {
    const { requiredList, selectedClockInDate, selectedClockInTime } =
      this.state;

    // Check if all required fields are present
    const hasEmptyFields = requiredList.some((field) => !this.state[field]);

    // Ensure clockIn date and time are combined correctly (both selectedClockInDate and selectedClockInTime must be present)
    const isClockInValid = selectedClockInDate && selectedClockInTime;

    return hasEmptyFields || !isClockInValid; // Save button is disabled if any required field is missing or clockIn is incomplete
  };

  getValue = (key) => {
    // Check if editEmployeeSession is defined, then access the value
    if (!this.props.editEmployeeSession) {
      return ''; // Return empty string or any fallback value if editEmployeeSession is null or undefined
    }

    const value = this.props.editEmployeeSession[key];

    // Check for undefined, null, or empty string and return fallback value
    if (value === undefined || value === null || value === '') {
      return ''; // Default empty string if value is invalid
    }

    return value;
  };

  handleSave = () => {
    const { name, clockIn, clockOut, totalPay, totalHours, state } = this.state;

    const data = {
      locationId: this.props.user.selectedLocationId,
      userId: this.props.user.userId,
      clockId: this.getValue('clockId'),
      name,
      clockIn,
      clockOut,
      totalPay,
      totalHours,
      state,
    };

    this.props.manualClockIn(
      data,
      (data) => {
        this.props.handleEditingClear();
        this.props.openFeedbackBar('success', 'Saved');
      },
      (message) => {
        this.props.openFeedbackBar('error', message);
      }
    );
  };

  render() {
    const {
      selectedClockInDate,
      selectedClockInTime,
      selectedClockOutDate,
      selectedClockOutTime,
    } = this.state;

    const filteredEmployees = this.props.employees.filter((employee) => {
      const employeeRoles = employee.authorities.map((auth) => auth.authority);

      // Check if employee has ROLE_ADMIN
      if (employeeRoles.includes('ROLE_ADMIN')) {
        return false;
      }

      // Check if the employee has exactly two roles and both are ROLE_DASHBOARD & ROLE_USER
      if (
        employeeRoles.length === 2 &&
        employeeRoles.includes('ROLE_DASHBOARD') &&
        employeeRoles.includes('ROLE_USER')
      ) {
        return false;
      }

      return true;
    });

    return (
      <React.Fragment>
        {/*<ErrorFeedbackBar/>*/}
        <TopToolbar
          pageName={
            this.props.editEmployeeSession
              ? EDIT_EMPLOYEE_SESSION
              : ADD_EMPLOYEE_SESSION
          }
          menuItems={[
            {
              title: BACK,
              icon: <KeyboardBackspaceIcon />,
              onClick: () => {
                this.props.handleEditingClear();
              },
            },
            {
              title: 'Save',
              icon: <SaveIcon />,
              disabled: this.isHandleSave(),
              onClick: () => this.handleSave(),
            },
          ]}
        />

        <div style={{ marginTop: '24px' }}>
          <div>
            <div className="rowSpecEmployee">
              <Autocomplete
                options={filteredEmployees}
                getOptionLabel={(user) => user.firstname}
                className="input-text-field"
                name="name"
                value={this.state.name}
                onChange={(event, value) => {
                  this.setState({
                    name: value,
                    hourlyRate: parseFloat(value.employeePerHour),
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Employee Name"
                    required={this.state.requiredList.includes('name')}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    name="name"
                  />
                )}
              />

              <Autocomplete
                className="input-text-field"
                options={STATE_OPTIONS}
                getOptionLabel={(option) => option.name}
                value={
                  STATE_OPTIONS.find(
                    (option) => option.name === this.state.state
                  ) || null
                }
                onChange={
                  (e, value) => this.handleStateChange('state', value.name) // Pass the correct parameters to handleChange
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="state"
                    label="State"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </div>

            <div className="rowSpecEmployee clock">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {/* Date Picker */}
                <KeyboardDatePicker
                  className="input-text-field"
                  autoOk
                  name="clockInDate"
                  label="ClockIn Date"
                  variant="inline"
                  inputVariant="outlined"
                  format="yyyy-MM-dd"
                  InputAdornmentProps={{ position: 'start' }}
                  onChange={this.handleClockInDateChange}
                  value={selectedClockInDate || null} // Use selectedClockInDate for initial value
                  // disabled={disabled}
                  required={this.state.requiredList.includes('clockIn')}
                />
              </MuiPickersUtilsProvider>

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {/* Time Picker */}
                <KeyboardTimePicker
                  className="input-text-field"
                  autoOk
                  name="clockInTime"
                  label="ClockIn Time"
                  variant="inline"
                  inputVariant="outlined"
                  InputAdornmentProps={{ position: 'start' }}
                  onChange={this.handleClockInTimeChange}
                  value={selectedClockInTime || null} // Use selectedClockInTime for initial value
                  // disabled={disabled}
                  required={this.state.requiredList.includes('clockIn')}
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className="rowSpecEmployee clock">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {/* Date Picker */}
                <KeyboardDatePicker
                  className="input-text-field"
                  autoOk
                  name="clockOutDate"
                  label="ClockOut Date"
                  variant="inline"
                  inputVariant="outlined"
                  format="yyyy-MM-dd"
                  InputAdornmentProps={{ position: 'start' }}
                  onChange={this.handleClockOutDateChange}
                  value={selectedClockOutDate || null} // Use selectedClockInDate for initial value
                />
              </MuiPickersUtilsProvider>

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {/* Time Picker */}
                <KeyboardTimePicker
                  className="input-text-field"
                  autoOk
                  name="clockOutTime"
                  label="ClockOut Time"
                  variant="inline"
                  inputVariant="outlined"
                  InputAdornmentProps={{ position: 'start' }}
                  onChange={this.handleClockOutTimeChange}
                  value={selectedClockOutTime || null}
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className="rowSpecEmployee clockk">
              <TextField
                className="input-text-field"
                variant="outlined"
                label="Total Working Hours"
                InputLabelProps={{ shrink: true }}
                name="totalHours"
                value={this.state.totalHours}
                onChange={this.handleChange}
              />

              <TextField
                className="input-text-field"
                variant="outlined"
                label="Total Pay"
                InputLabelProps={{ shrink: true }}
                name="totalPay"
                value={this.state.totalPay}
                onChange={this.handleChange}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default EmployeeSessionForm;
